export default {
    EmployeeComplianceReminders: 'webapi_employee_compliance_reminders_enabled',
    CondensedPerformanceReviews: 'condensed_performance_reviews',
    Billing: 'billing_manage',
    AssetRegister: 'asset_register',
    Certifications: 'certifications'
}